import React, { useState } from 'react';
import './styles/footer.scss';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Avatar } from '@mui/material';
import Stack from '@mui/material/Stack';
import { trackEvent } from '../../../utils/analytics';

const DigitalPaymentFooter = () => {
  const [expanded, setExpanded] = useState(null);
  const handleChange = panelId => (event, isExpanded) => {
    trackEvent(
      'Digital payment - Click contact us',
      'Digital payment - Click contact us',
    );
    setExpanded(isExpanded ? panelId : null);
  };

  const renderIcon = panelId => (
    <span className="icon">{expanded === panelId ? '-' : '+'}</span>
  );

  const accordionData = [
    {
      id: 'panel6',
      title: 'Contact Us',
      links: [],
    },
  ];

  const handleClickTel = () => {
    trackEvent('Digital payment - Click 1621', 'Digital payment - Click 1621');
  };

  const handleFacebookLink = () => {
    trackEvent(
      'Digital payment - Click Facebook',
      'Digital payment - Click Facebook',
    );
  };

  const handleLineLink = () => {
    trackEvent('Digital payment - Click LINE', 'Digital payment - Click LINE');
  };

  const handleTikTokLink = () => {
    trackEvent(
      'Digital payment - Click Tiktok',
      'Digital payment - Click Tiktok',
    );
  };

  const handleXLink = () => {
    trackEvent('Digital payment - Click X', 'Digital payment - Click X');
  };

  return (
    <div className="footer-digital-payment mt-5 mx-0">
      <div className={`accordion-container`}>
        {accordionData.map(item => {
          const isSpecialTitle = item.title === 'Contact Us';
          if (isSpecialTitle) {
            return (
              <>
                <Accordion
                  key={item.id}
                  expanded={expanded === item.id}
                  onChange={handleChange(item.id)}
                >
                  <AccordionSummary
                    aria-controls={`${item.id}-content`}
                    id={`${item.id}-header`}
                  >
                    <div className="summary-content">
                      <span style={{ fontSize: '18px', fontWeight: 'lighter' }}>
                        {item.title}
                      </span>
                      {renderIcon(item.id)}
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    {/* <div className="rich-text" > */}
                    <p
                      style={{
                        fontSize: '16px',
                        fontWeight: 'lighter',
                        lineHeight: '1.4rem',
                      }}
                    >
                      ที่อยู่:
                      <br />
                      เลขที่ 944 มิตรทาวน์ ออฟฟิศ ทาวเวอร์ ชั้น 10, 29-31
                      ถนนพระราม 4 แขวงวังใหม่ เขตปทุมวัน กรุงเทพฯ 10330 <br />
                      <br />
                      ศูนย์บริการลูกค้า:
                      <br />
                      <a
                        href="tel:1621"
                        style={{ color: 'white' }}
                        onClick={handleClickTel}
                      >
                        1621
                      </a>
                    </p>
                    {/* </div> */}
                  </AccordionDetails>
                </Accordion>
              </>
            );
          }
          return <></>;
        })}
      </div>

      {/* footer */}
      <div className="bottom-footer">
        <div className="container bottom-footer__inner">
          <div className="legal-infor">
            <div className="rich-text">
              <p>
                บริษัท พรูเด็นเชียล ประกันชีวิต (ประเทศไทย) จำกัด (มหาชน)
                เป็นบริษัท ย่อยทางอ้อมของกลุ่มบริษัทพรูเด็นเชียล
                ซึ่งเป็นบริษัทที่ดำเนินธุรกิจในเอเชีย และแอฟริกา&nbsp;ทั้งบริษัท
                พรูเด็นเชียล ประกันชีวิต (ประเทศไทย) จำกัด (มหาชน)
                และกลุ่มบริษัทพรูเด็นเชียล&nbsp;มิได้มีความสัมพันธ์ใดๆ&nbsp;กับ
                พรูเด็นเชียล ไฟแนนเชียล อิงค์ (Prudential Financial.
                Inc)&nbsp;ซึ่งเป็นบริษัทที่มีถิ่นที่ตั้งทางธุรกิจในประเทศ
                สหรัฐอเมริกา
              </p>
              <p>
                <br />
                สงวนลิขสิทธิ์ 2567 บมจ. พรูเด็นเชียล ประกันชีวิต (ประเทศไทย).
              </p>
            </div>
          </div>
          <div className="container">
            <Stack
              direction="row"
              sx={{
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <a
                href="https://www.facebook.com/PrudentialThai"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleFacebookLink}
              >
                <Avatar className="avatar-large">
                  <img
                    alt="facebook-icon.png"
                    src="/assets/images/digital-payment/facebook-icon.png"
                    width={20}
                    height={20}
                  />
                </Avatar>
              </a>
              <a
                href="https://line.me/R/ti/p/%40prudentialthailand"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLineLink}
              >
                <Avatar className="avatar-large">
                  <img
                    alt="line-icon-20x20.png"
                    src="/assets/images/digital-payment/line-icon-20x20.png"
                  />
                </Avatar>
              </a>
              <a
                href="https://www.tiktok.com/@prudentialthailand"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleTikTokLink}
              >
                <Avatar className="avatar-large">
                  <img
                    alt="tiktok-icon-25x25.png"
                    src="/assets/images/digital-payment/tiktok-icon-25x25.png"
                  />
                </Avatar>
              </a>
              <a
                href="https://twitter.com/prudentialthai"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleXLink}
              >
                <Avatar className="avatar-large">
                  <img
                    alt="x-icon-25x25.png"
                    src="/assets/images/digital-payment/x-icon-25x25.png"
                  />
                </Avatar>
              </a>
            </Stack>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalPaymentFooter;
